import React from "react";
import { container_classname } from "../constants";

interface PricingTabsValue {
    name: string;
}

interface PricingToggleSectionProps {
    pricingTabs: PricingTabsValue[];
    radioValue: string;
    handleRadioChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    isDollar: boolean;
}

const PricingToogle: React.FC<PricingToggleSectionProps> = ({ pricingTabs, radioValue, handleRadioChange, isDollar }) => {
    return (
        <section className={`${container_classname} pt-16`}>
            <div
                className={`mx-auto w-fit md:p-3 border border-solid
                grid ${isDollar ? "grid-cols-2" : "grid-cols-3"} border-gray-500 rounded-lg
                md:flex md:flex-row md:gap-5 md:border-gray-900 md:rounded-lg md:grid-cols-none`}
            >
                {pricingTabs.map((tab) => (
                    <label
                        htmlFor={tab.name}
                        key={tab.name}
                        className={`cursor-pointer flex items-center justify-center px-3 py-2 rounded-md ${
                            radioValue === tab.name ? "bg-black text-white" : "md:hover:bg-gray-200"
                        }`}
                    >
                        <input type="radio" value={tab.name} id={tab.name} onChange={handleRadioChange} checked={radioValue === tab.name} className="absolute opacity-0" />
                        <div className="capitalize font-semibold">
                            <span>
                                {["anual", "yearly", "quarterly"].includes(tab.name) ? (
                                    <>
                                        {tab.name} <br className="md:hidden block" />
                                        <span
                                            style={{
                                                color: radioValue === tab.name ? "#99CEFF" : "#0069CC",
                                                fontSize: "14px",
                                            }}
                                        >
                                            {!isDollar ? (tab.name === "quarterly" ? "SAVE 15%" : "SAVE 25%") : tab.name === "quarterly" ? "SAVE 15%" : "SAVE 40%"}
                                        </span>
                                    </>
                                ) : (
                                    tab.name
                                )}
                            </span>
                        </div>
                    </label>
                ))}
            </div>
        </section>
    );
};

export default PricingToogle;
